import { render, staticRenderFns } from "./ca-history.vue?vue&type=template&id=16a5e712&"
import script from "./ca-history.vue?vue&type=script&lang=js&"
export * from "./ca-history.vue?vue&type=script&lang=js&"
import style0 from "./ca-history.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports